import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { asyncReceiveBookmarks } from '../../store/plain/bookmarks/action';
import { ThreadExcerpt } from './ThreadExcerpt';

export function BookmarksDisplay() {
  const { bookmarks = [] } = useSelector((state) => state);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(asyncReceiveBookmarks());
  }, [dispatch]);

  return (
    <div>
      {bookmarks.length > 0 ? (
        <ul className="mb-16 grid divide-y divide-gray-200 overflow-hidden dark:divide-gray-800">
          {bookmarks.map((bookmark) => (
            <li
              key={bookmark.id}
              className="py-2 hover:bg-indigo-500/5 dark:hover:bg-indigo-900/5"
            >
              <ThreadExcerpt thread={bookmark} />
            </li>
          ))}
        </ul>
      ) : (
        <div className="my-4">Your bookmarks is empty</div>
      )}
    </div>
  );
}
